import classNames from "classnames";
import React, { FC } from "react";

import TorikizokuLogo from "../../assets/images/TorikizokuLogo.png";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { Image } from "../elements";
import "./Logo_torikizoku.scss";

interface ILogoProps {
	"data-testid"?: string;
	className?: string;
}

const Logo: FC<ILogoProps> = (props) => {
	const { state: location } = useConfigContext((state) => state.location);

	return (
		<div
			data-testid={props["data-testid"] ?? "LogoCntr"}
			className={classNames("LogoCntr", props.className)}
		>
			<Image src={TorikizokuLogo} alt="Company Logo" className="Logo" />
			{location?.name && <span className="LogoText">{location.name}</span>}
		</div>
	);
};

export default Logo;
